/**
 * AI Multi-Column Media Section - Structural Controller Script
 * Optimized with instant zero-threshold viewport interaction tracking.
 */

class MultiColumnMediaSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVideoControls();
    this.initScrollAnimations();
    
    // Re-initialize controls seamlessly if theme customizer dynamically refreshes
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail.sectionId === this.id.replace('SectionProvider-', '')) {
          this.initVideoControls();
          this.initScrollAnimations();
        }
      });
    }
  }

  initVideoControls() {
    const playPauseButtons = this.querySelectorAll('.ai-multi-column-media__play-pause');
    const muteButtons = this.querySelectorAll('.ai-multi-column-media__mute-unmute');

    // Setup Master Play / Pause Element Click Handles
    playPauseButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const videoId = btn.getAttribute('data-video-id');
        const video = this.querySelector(`video[data-video-id="${videoId}"]`);
        if (!video) return;

        const playIcon = btn.querySelector('.ai-multi-column-media__play-icon');
        const pauseIcon = btn.querySelector('.ai-multi-column-media__pause-icon');

        if (video.paused) {
          video.play().catch(() => {});
          if (playIcon) playIcon.style.display = 'none';
          if (pauseIcon) pauseIcon.style.display = 'block';
        } else {
          video.pause();
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
        }
      });
    });

    // Setup Audio Stream Mute / Unmute Toggle Controls
    muteButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const videoId = btn.getAttribute('data-video-id');
        const video = this.querySelector(`video[data-video-id="${videoId}"]`);
        if (!video) return;

        const muteIcon = btn.querySelector('.ai-multi-column-media__mute-icon');
        const unmuteIcon = btn.querySelector('.ai-multi-column-media__unmute-icon');

        if (video.muted) {
          video.muted = false;
          if (muteIcon) muteIcon.style.display = 'none';
          if (unmuteIcon) unmuteIcon.style.display = 'block';
        } else {
          video.muted = true;
          if (muteIcon) muteIcon.style.display = 'block';
          if (unmuteIcon) unmuteIcon.style.display = 'none';
        }
      });
    });
  }

  initScrollAnimations() {
    const items = this.querySelectorAll('.ai-multi-column-media__item');
    if (!items.length) return;

    // YOUR INSTANT OPTIONS: Trigger as soon as 1px is visible on screen
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    };

    const bannerObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const slide = entry.target;

          // 3. Video Playback inline stream ignition with your exact 800ms presentation delay
          const videos = slide.querySelectorAll('.ai-multi-column-media__video');
          videos.forEach(video => {
            setTimeout(() => {
              video.play().catch(() => {}); 
              
              // Sync up custom UI play indicators automatically when playing starts
              const blockId = video.getAttribute('data-video-id');
              const pBtn = this.querySelector(`.ai-multi-column-media__play-pause[data-video-id="${blockId}"]`);
              if (pBtn) {
                const playIcon = pBtn.querySelector('.ai-multi-column-media__play-icon');
                const pauseIcon = pBtn.querySelector('.ai-multi-column-media__pause-icon');
                if (playIcon) playIcon.style.display = 'none';
                if (pauseIcon) pauseIcon.style.display = 'block';
              }
            }, 800); 
          });

          // 4. Stop watching this specific column item once triggered
          observer.unobserve(slide);
        }
      });
    }, observerOptions);

    items.forEach(item => bannerObserver.observe(item));
  }
}

// Define the core Custom Element signature safely if not registered
if (!customElements.get('multi-column-media-section')) {
  customElements.define('multi-column-media-section', MultiColumnMediaSection);
}